import { Button, Flex, Typography } from "@aloft/toolkit-sui";
import { AddressInput } from "./AddressInput.tsx";
import { useFormContext, useWatch } from "react-hook-form";
import { Address } from "@aloft/toolkit-shared";
import { Divider } from "@aloft/toolkit-sui/chakra";

export const AddressInputs = () => {
  const { setValue, getValues } = useFormContext();
  const addressesCount: number = useWatch({ name: 'addresses.length' });
  const handleAddAddress = () => {
    const addresses = getValues('addresses');
    setValue('addresses', [...addresses, {
      AddressLineText: '',
      unitNumber: '',
      CityName: '',
      StateCode: '',
      PostalCode: '',
    }]);
  }

  const handleRemoveAddress = (index: number) => {
    const addresses = getValues('addresses');
    setValue('addresses', addresses.filter((_: Address, i: number) => i !== index));
  }


  return (
    <Flex gap={3} flexDirection="column">
      {Array.from({ length: addressesCount }).map((_, index) => (
        <AddressInput key={`address_${index}`} index={index} onRemove={handleRemoveAddress} />
      ))}
      <Flex>
        <Button variant="inline" onClick={handleAddAddress} text="Add another entry" icon="add-circle" />
      </Flex>
      <Flex position="relative" alignItems="center" justifyContent="center" marginBottom={2}>
        <Divider borderColor="strokeLight" />
        <Flex position="absolute" backgroundColor="surface1" padding="0 1rem">
          <Typography color="textTertiary" variant="body2">OR</Typography>
        </Flex>
      </Flex>
    </Flex>
  );
};
